import { render } from "./CardDepositView.vue?vue&type=template&id=b5c4072c&scoped=true"
import script from "./CardDepositView.vue?vue&type=script&lang=js"
export * from "./CardDepositView.vue?vue&type=script&lang=js"

import "./CardDepositView.vue?vue&type=style&index=0&id=b5c4072c&scoped=true&lang=scss"
import "./CardDepositView.vue?vue&type=style&index=1&id=b5c4072c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c4072c"]])

export default __exports__